import { z } from "zod";

const schema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_COGNITO_REGION: z.string().min(1),
  VITE_COGNITO_USER_POOL_ID: z.string().min(1),
  VITE_COGNITO_CLIENT_ID: z.string().min(1),
  VITE_RAZORPAY_KEY_ID: z.string().min(1).default("rzp_test_placeholder"),
  VITE_APP_ORIGIN: z.string().url().default("http://localhost:5174"),
  VITE_ENV: z.enum(["dev", "preview", "prod"]).default("dev"),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  // Surface missing config loudly in dev. In production this would render an
  // error boundary rather than crash silently with a confusing 401 later.
  console.error("Invalid environment configuration", parsed.error.flatten().fieldErrors);
  throw new Error(
    "Missing required VITE_* environment variables. See frontend-v2/.env.example for the full list.",
  );
}

export const env = parsed.data;

// Build-time feature flag, read directly from import.meta.env (not the zod
// schema above) so an unset var defaults sensibly instead of crashing the
// app -- same pattern as VITE_PAYMENTS_ENABLED in lib/razorpay.ts. Gates the
// /parent/* routes, the student-side invite card, and the invite-link signup
// variant. The backend guards (guard_role/guard_parent_of) are the always-on
// control; flipping this in prod requires a rebuild + redeploy, not just a
// config change.
const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);
export function isParentPortalEnabled(): boolean {
  const raw = import.meta.env.VITE_PARENT_PORTAL_ENABLED;
  if (raw == null || raw === "") return true; // default on in dev
  return TRUE_VALUES.has(String(raw).trim().toLowerCase());
}
